import { motion } from 'motion/react'
import { LogoEmblem } from './LogoEmblem'

interface BrandLogoProps {
  placement: 'header' | 'hero'
}

/** Uma única logo visual — troca de lugar com layoutId (navy → header). */
export function BrandLogo({ placement }: BrandLogoProps) {
  const hero = placement === 'hero'

  return (
    <motion.div
      layoutId="cr-brand-logo"
      className={hero ? 'cr-brand-logo cr-brand-logo--hero' : 'cr-brand-logo cr-brand-logo--header'}
      transition={{ type: 'spring', stiffness: 280, damping: 28, mass: 0.85 }}
    >
      <LogoEmblem size={hero ? 'hero' : 'sm'} interactive />
    </motion.div>
  )
}
